module.exports = __webpack_public_path__ + "img/사무라이.74d1a89f.png";